import type { JSX } from "preact";
import { Alert } from "@gss/components/Alert";
import type {
    FilterSeriesDimensionScore,
    FilterSeriesQuestionScore,
    FilterSeriesStatError,
} from "../filters/filters.types";
import "./TooFewRespondents.css";
import { useTranslation } from "../util/Translation";

interface Props {
    series?: (
        | FilterSeriesDimensionScore
        | FilterSeriesQuestionScore
        | FilterSeriesStatError
    )[];
}

export function TooFewRespondents({ series }: Props): JSX.Element | null {
    const t = useTranslation().translation.error;

    if (series == null || series.length === 0) {
        return null;
    }

    return (
        <Alert variant="info" className="too-few-respondents">
            {t.tooFewRespondents}
            <ul className="ps-3 mt-3 mb-0">
                {series.map((s) => {
                    const count = (() => {
                        if ("stat" in s) {
                            return s.stat.invitees.answered;
                        }
                        if ("question" in s) {
                            return s.question.respondents;
                        }
                        return 0;
                    })();
                    return (
                        <li
                            key={s.filterSerie.key}
                            style={{ color: s.filterSerie.color }}
                        >
                            {s.filterSerie.name} ({count})
                        </li>
                    );
                })}
            </ul>
        </Alert>
    );
}
